/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ITumorBoard } from 'app/shared/model/tumor-board.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';

export interface ITumorBoardOccurrence {
  id?: string;
  eventName?: string;
  eventDescription?: string | null;
  scheduleStartTime?: number;
  scheduleEndTime?: number;
  scheduleDate?: number | null;
  outcomeSummary?: string | null;
  startedAt?: number;
  completedAt?: number;
  createdById?: string | null;
  createdByType?: keyof typeof AddedByType | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  board?: ITumorBoard | null;
}

export const defaultValue: Readonly<ITumorBoardOccurrence> = {
  active: false,
};
